import {biLoggerFactory} from 'wix-private';

const BI_BASE_URL = "https://frog.wix.com/lp?src=19&evid=703";
const biLogger = biLoggerFactory('lp', 19)

export async function sendBiEvent(buttonName){
	const url = 'https://www.wix.com/tools/invoice-generator';
	const topic = 'wix-marketing-tools';
	const isValid = true;
	const obj = {evid: 703, button_name: buttonName, is_valid: isValid, topic, url};
    // console.log("BI");
	Promise.resolve(biLogger.log(obj)); 
	return true;
}